import Slide from './Slide';
let PIXI;
if (typeof window !== 'undefined') {
  PIXI = require('pixi.js');
}

const closeAlpha = 0.95;
const breakpoint = 800;

class ImageSliderPixi {
  currentIndex = 0;
  slidesCreated = 0;
  constructor(
    containerEl,
    imgs,
    width = window.innerWidth,
    height = window.innerHeight
  ) {
    this.app = new PIXI.Application({
      width: width,
      height: height,
      antialias: false,
      transparent: true,
      resolution: 1,
    });
    this.imgs = imgs;
    this.size = imgs.length;
    if (this.size === 1) {
      this.draw = this.drawOne;
      this.open = this.openOne;
      this.close = this.closeOne;
    } else if (this.size === 2) {
      this.draw = this.drawTwo;
      this.open = this.openTwo;
      this.close = this.closeTwo;
    } else {
      this.draw = this.drawThree;
      this.open = this.openThree;
      this.close = this.closeThree;
    }
    // make pixi full screen
    this.app.renderer.view.style.position = 'absolute';
    this.app.renderer.view.style.display = 'block';
    this.app.renderer.autoResize = true;
    containerEl.appendChild(this.app.view);
    this.createSlides();
    // this.loadImages(imgs, this.createSlides);
  }
  closeSection = activeIndex => {
    const current = this.currentIndex;
    const nextIndex = this.getNextIndex();
    const prevIndex = this.getPrevIndex();
    if (this.slides.length >= 3) {
      this.slides.forEach(slide => {
        if (slide.index === current) {
          // move(size, alpha, screenAlign = true, darken = false, duration = 1) {

          slide.move('full', 0.6, undefined, undefined, 0.7);
        } else if (slide.index === prevIndex) {
          slide.move('offLeft', closeAlpha, undefined, undefined, 0.7);
        } else if (slide.index === nextIndex) {
          slide.move('offRight', closeAlpha, undefined, undefined, 0.7);
        } else {
          slide.off();
        }
      });
    } else if (this.slides.length === 2) {
      this.slides.forEach(slide => {
        if (slide.index === 0) {
          slide.move('full', 0.6, undefined, undefined, 0.7);
        } else {
          slide.move('offRight', closeAlpha, undefined, undefined, 0.7);
        }
      });
    } else {
      this.slides.forEach(slide => {
        if (slide.index === current) {
          // move(size, alpha, screenAlign = true, darken = false, duration = 1) {
          slide.move('full', 0.6, undefined, undefined, 0.7);
        } else {
          slide.off();
        }
      });
    }
  };
  openOne = () => {
    this.slides[0].move('full', 0, false);
  };
  openTwo = openIndex => {
    if (window.innerWidth > breakpoint) {
      if (openIndex === 0) {
        this.slides[0].move('full', 0, false);
        this.slides[1].move('offRight', closeAlpha, false, true);
      } else {
        this.slides[1].move('full', 0);
        this.slides[0].move('offLeft', closeAlpha, false);
      }
    } else {
      if (this.currentIndex === 0) {
        this.slides[0].move('full', 0);
        this.slides[1].draw('offRight');
      } else {
        this.slides[0].draw('offLeft');
        this.slides[1].move('full', 0);
      }
    }
  };
  openThree = () => {
    const current = this.currentIndex;
    const nextIndex = this.getNextIndex();
    const prevIndex = this.getPrevIndex();
    this.slides.forEach(slide => {
      if (slide.index === current) {
        slide.move('full', 0);
      } else if (slide.index === prevIndex) {
        slide.move('offLeft', closeAlpha);
      } else if (slide.index === nextIndex) {
        slide.move('offRight', closeAlpha);
      } else {
        slide.off();
      }
    });
  };
  closeOne = () => {
    this.slides[0].move('full', 0.6, false);
  };
  closeTwo = () => {
    if (window.innerWidth > breakpoint) {
      this.slides[0].move('halfLeft', 'default', false);
      this.slides[1].move('halfRight', 'default', false, true);
    } else {
      if (this.currentIndex === 0) {
        this.slides[0].move('full');
        this.slides[1].move('offRight');
      } else {
        this.slides[0].move('offLeft');
        this.slides[1].move('full');
      }
    }
  };
  closeThree = () => {
    const current = this.currentIndex;
    const nextIndex = this.getNextIndex();
    const prevIndex = this.getPrevIndex();
    if (window.innerWidth > breakpoint) {
      this.slides.forEach(slide => {
        if (slide.index === current) {
          slide.move('center');
        } else if (slide.index === prevIndex) {
          slide.move('left');
        } else if (slide.index === nextIndex) {
          slide.move('right');
        } else {
          slide.off();
        }
      });
    } else {
      this.slides.forEach(slide => {
        if (slide.index === current) {
          slide.move('full');
        } else if (slide.index === prevIndex) {
          slide.move('offLeft');
        } else if (slide.index === nextIndex) {
          slide.move('offRight');
        } else {
          slide.off();
        }
      });
    }
  };
  nextSlide = () => {
    const current = this.currentIndex;
    const exitingIndex = this.getPrevIndex();
    const nextIndex = this.getNextIndex();
    this.currentIndex = nextIndex;
    const enteringIndex = this.getNextIndex();
    if (window.innerWidth > breakpoint) {
      this.slides.forEach(slide => {
        if (slide.index === current) {
          slide.move('left');
        } else if (slide.index === exitingIndex) {
          slide.move('offLeft');
        } else if (slide.index === nextIndex) {
          slide.move('center');
        } else if (slide.index === enteringIndex) {
          slide.enterFromRight();
        } else {
          slide.off();
        }
      });
    } else {
      if (this.size === 2) {
        this.slides[1 - current].draw('offRight');
        this.slides[1 - current].move('full');
        this.slides[current].move('offLeft');
      } else {
        this.slides.forEach(slide => {
          if (slide.index === current) {
            slide.move('offLeft');
          } else if (slide.index === exitingIndex) {
            slide.move('offLeft');
          } else if (slide.index === nextIndex) {
            slide.move('full');
          } else if (slide.index === enteringIndex) {
            slide.draw('offRight');
          } else {
            slide.off();
          }
        });
      }
    }
  };
  prevSlide = () => {
    const current = this.currentIndex;
    const exitingIndex = this.getNextIndex();
    const prevIndex = this.getPrevIndex();
    this.currentIndex = prevIndex;
    const enteringIndex = this.getPrevIndex();

    if (window.innerWidth > breakpoint) {
      this.slides.forEach(slide => {
        if (slide.index === current) {
          slide.move('right');
        } else if (slide.index === exitingIndex) {
          slide.move('offRight');
        } else if (slide.index === prevIndex) {
          slide.move('center');
        } else if (slide.index === enteringIndex) {
          slide.enterFromLeft();
        } else {
          slide.off();
        }
      });
    } else {
      if (this.size === 2) {
        this.slides[1 - current].draw('offLeft');
        this.slides[1 - current].move('full');
        this.slides[current].move('offRight');
      } else {
        this.slides.forEach(slide => {
          if (slide.index === current) {
            slide.move('offRight');
          } else if (slide.index === exitingIndex) {
            slide.move('offRight');
          } else if (slide.index === prevIndex) {
            slide.move('full');
          } else if (slide.index === enteringIndex) {
            slide.draw('offLeft');
          } else {
            slide.off();
          }
        });
      }
    }
  };
  drawOne = () => {
    this.slides.forEach(slide => {
      slide.draw('full', false);
    });
  };
  drawTwo = () => {
    if (window.innerWidth > breakpoint) {
      this.slides[0].draw('halfLeft', false);
      this.slides[1].draw('halfRight', false, true);
    } else {
      if (this.currentIndex === 0) {
        this.slides[0].draw('full');
        this.slides[1].draw('offRight');
      } else {
        this.slides[1].draw('full');
        this.slides[0].draw('offLeft');
      }
    }
  };

  drawThree = () => {
    const currentIndex = this.currentIndex;
    const prevIndex = this.getPrevIndex();
    const nextIndex = this.getNextIndex();

    if (window.innerWidth > breakpoint) {
      this.slides.forEach(slide => {
        if (slide.index === this.currentIndex) {
          slide.draw('center');
        } else if (slide.index === prevIndex) {
          slide.draw('left');
        } else if (slide.index === nextIndex) {
          slide.draw('right');
        } else {
          slide.off();
        }
      });
    } else {
      this.slides.forEach(slide => {
        if (slide.index === this.currentIndex) {
          slide.draw('full');
        } else if (slide.index === prevIndex) {
          slide.draw('offLeft');
        } else if (slide.index === nextIndex) {
          slide.draw('offRight');
        } else {
          slide.off();
        }
      });
    }
  };

  getPrevIndex() {
    if (this.currentIndex === 0) {
      return this.size - 1;
    }
    return this.currentIndex - 1;
  }
  getNextIndex() {
    if (this.currentIndex === this.size - 1) {
      return 0;
    }
    return this.currentIndex + 1;
  }
  onSlideCreated = () => {
    this.slidesCreated += 1;
    if (this.slidesCreated === this.size) {
      this.draw();
    }
  };
  createSlides = () => {
    if (this.slides) {
      this.draw();
      return;
    }

    if (this.size >= 3 && this.size <= 4) {
      this.imgs = [...this.imgs, ...this.imgs];
      this.size = this.size * 2;
    }
    this.slides = this.imgs.map((img, i) => {
      const slide = new Slide(img, i, this.app, this.onSlideCreated, 0.5, 0.5);
      this.app.stage.addChild(slide.getContainer());
      return slide;
    });
  };

  updatePixiSize = (width, height) => {
    this.app.renderer.resize(width, height);
    this.draw();
  };

  getView() {
    return this.app.view;
  }
}

export default ImageSliderPixi;



// WEBPACK FOOTER //
// ./src/components/PixiPressPlay/ImageSliderPixi.js